export default __webpack_public_path__ + "static/media/forms.c0019a0e.svg";